import api from "../interceptor/interceptor";

export const VideoTelematicService = {
    async getDvrVideoList(
        alertType = [],
        vehicles = [],
        startDate = "",
        endDate = "",
        pNumber = 1,
        pSize = 15,
        filters
    ) {
        try {
            const response = await api.post(`/api/dvr/list?pSize=${pSize}&pNumber=${pNumber}
            &vehicleId=${filters?.vehicles?.join(',')}&vehicleGroupId=${filters?.groups?.join(',')}&alertNames=${filters?.alerts}`,
            {
                "vehicles": vehicles,
                "alertType": alertType,
                "startDate": startDate,
                "endDate": endDate,
                "pageNum": 1,
              }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            return response.data;
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    },

    async getDvrVideoListSummary({
        alertType = [],
        vehicles = [],
        startDate = "",
        endDate = "",
        pNumber = 1,
        pSize = 15
    }) {
        try {
            const response = await api.post(`/alerts/dvr/video/list-summary?pSize=${pSize}&pNumber=${pNumber}`,
            {
                "vehicles": vehicles,
                "alertType": alertType,
                "startDate": startDate,
                "endDate": endDate
              }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            return response.data;
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    }
}
